import React, { useEffect, useState, useContext } from 'react';
import axiosConfig from '../../../../../utils/axiosConfig';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import Alert from '@material-ui/lab/Alert';
import { IconButton, LinearProgress  } from '@material-ui/core';

import {
    Assignment as AssignmentIcon,
    Close as CloseIcon,
    Delete as DeleteIcon,
    PeopleAltTwoTone as PeopleAltTwoToneIcon
} from '@material-ui/icons';

import {
    Avatar, Box, Button, ButtonBase, Grid, List, ListItem, ListItemText,
    ListItemAvatar, Paper, Typography
} from '@material-ui/core';
import './ClassworkSubmissions.css';

import { StateContext } from '../../../../../context/Provider';

const ClassworkSubmissions = (props) => {

    const { classcode, classwork_id } = useParams();
    const [submissionStatus, setSubmissionStatus] = useState('Assigned');
    // const [submissions, setSubmissions] = useState([]);
    const [customErrorMessage, setCustomErrorMessage] = useState('');
    const [errorMessages, setErrorMessages] = useState([]);
    const [successMsg, setSuccessMsg] = useState('');

    const [fileUploadLabel, setFileUploadLabel] = useState('Choose a file to upload');
    const [file, setFile] = useState('');
    const [disabled, setDisabled] = useState(false);

    const appState = useContext(StateContext);
    const { authState, globalState } = appState;

    // 10072021
    const [files, setFiles] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);

    const [showUploadProgress, setShowUploadProgress] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)

    const handleFileChange = (event) => {
        try {
            // setFileUploadLabel(event.target.files[0].name);
            // setFile(event.target.files[0]);

            // console.log(event.target.files);
            // let images = [];
            // for (let i = 0; i < event.target.files.length; i++) {
            //     images.push(URL.createObjectURL(event.target.files[i]))
            // }
            // setPreviewImages(images);

            console.log(event.target.files[0]);

            let filesArr = [];

            for (let i = 0; i < event.target.files.length; i++) {
                filesArr.push(event.target.files[i]);
            }

            setFiles(filesArr);
            console.log(filesArr);

        } catch (e) {
            return;
        }
    }

    const removeFileFromArray = (selectedFile) => {
        let filesArr = [...files];
        let index = filesArr.indexOf(selectedFile);

        if (index !== -1) {
            filesArr.splice(index, 1);
            setFiles(filesArr);
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        setCustomErrorMessage('');
        setErrorMessages('');
        setSuccessMsg('');
        setDisabled(true);

        const formData = new FormData();
        // formData.append('file', file);
        formData.append('classwork_id', props.classworkID);
        for (let i=0;i<files.length;i++) {
            formData.append(`file[${i}]`, files[i]);
        }

        axiosConfig.post(`/submitClasswork`, formData, {
            onUploadProgress: (progress) => {
                let loaded = progress.loaded
                let total = progress.total

                let percentage = (loaded / total) * 100

                setShowUploadProgress(true)
                setUploadProgress(percentage)
            }
        })
            .then((res) => {
                setShowUploadProgress(false)
                if (res.data.status_code === 'ok') {
                    setSuccessMsg('Your work has been submitted.');
                    // setFileUploadLabel('Choose a file to upload');
                    // setFile('');
                    setFiles([]);
                    props.fetchClassworkSubmissions();
                }
            })
            .catch((err) => {
                setShowUploadProgress(false)
                if (err.response.status === 422) {
                    const errors = err.response.data.errors;

                    let errorMsgs = [];
                    Object.keys(errors).map((error, index) => {
                        if (errors[error].length > 0) {
                            errors[error].map((err1, index1) => {
                                errorMsgs.push(err1);
                            });
                        } else {
                            errorMsgs.push(errors[error][0]);
                        }
                    });

                    setErrorMessages(errorMsgs);
                }
            })
            .finally(() => {
                setDisabled(false);
            });
    }

    const handleUnsubmit = (e) => {
        console.log(e);
        axiosConfig.post(`/unsubmitClasswork`, {
            classwork_id: props.classworkID
        })
        .then((res) => {
            if (res.data.status_code === 'ok') {
                console.log(res.data);
                setSuccessMsg('Your work has been un-submitted.');
                props.fetchClassworkSubmissions();
            }
        })
        .catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {

        // console.log(props.submissions);
        if (props.submissions.length > 0) {
            setSubmissionStatus('Turned in');
        }

    }, [props.submissions]);

    return (
        <>
            {customErrorMessage && (
                <Box mb={1}>
                    <Alert severity="error" style={{width: '100%'}}>
                        <Typography>
                            {customErrorMessage}
                        </Typography>
                    </Alert>
                </Box>
            )}

            {errorMessages.length > 0 && (
                <Box mb={1}>
                    <Alert variant="filled" severity="error" style={{width: '100%'}}>
                        {errorMessages.map((key, i) => (
                            <Typography key={i}>
                                {key}
                            </Typography>
                        ))}
                    </Alert>
                </Box>
            )}

            {successMsg && (
                <Box mb={1}>
                    <Alert severity="success" style={{width: '100%'}}>
                        <Typography>
                            {successMsg}
                        </Typography>
                    </Alert>
                </Box>
            )}

            <Paper elevation={1}>
                <Box p={2}>
                    <Button
                        color="primary"
                        startIcon={<PeopleAltTwoToneIcon />}
                        // style={{textTransform: 'none', color: 'rgba(0, 0, 0, 0.54)'}}
                        style={{textTransform: 'none'}}
                        component={Link}
                        to={`/${classcode}/classworkSubmissionComments/${classwork_id}/${props.studentID}`}
                    >
                        Submission Comments ({`${props.submissionCommentCount}`})
                    </Button>
                </Box>
            </Paper>

            <Box mb={1} />

            <Paper elevation={1}>
                <Box p={2}>
                    <Grid container justify="space-between">
                        <Typography variant="h6" style={{fontWeight: 450}}>
                            Submissions
                        </Typography>

                        <Box pt={1}>
                            <Typography variant="subtitle2" style={{color: '#2e7d32'}}>
                                {submissionStatus}
                            </Typography>
                        </Box>
                    </Grid>

                    <Box mb={1} />

                    { props.submissions.length > 0 ?
                        (
                            <>
                                {props.submissions.map((submission, i) => (
                                    <Box pb={1} key={submission.id}>
                                        <Box className="custom-submission-item-box">
                                            <List dense={true} className="padding-0">
                                                <ButtonBase
                                                    disableRipple
                                                    href={submission.attachments_url || ''}
                                                    target="_blank"
                                                    download
                                                >
                                                    <ListItem>
                                                        <ListItemAvatar>
                                                            <Avatar>
                                                                <AssignmentIcon />
                                                            </Avatar>
                                                        </ListItemAvatar>

                                                        <ListItemText
                                                            primary="Submitted File"
                                                            style={{overflow: "hidden", textOverflow: "ellipsis", maxWidth: '13rem'}}
                                                            secondary={submission.attachments || ''}
                                                        />
                                                    </ListItem>
                                                </ButtonBase>
                                            </List>
                                        </Box>
                                    </Box>
                                ))}

                                <Box py={1}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        color="primary"
                                        fullWidth
                                        disableElevation
                                        disableRipple
                                        onClick={(e) => {
                                            if (window.confirm(`Are you sure you want to unsubmit your work?`)) {
                                                handleUnsubmit(e);
                                            }
                                        }}
                                    >
                                        Unsubmit
                                    </Button>
                                </Box>
                            </>
                        ) : (
                            <>
                                <form encType="multipart/form-data">

                                    {files.map((file, i) => (
                                        <Box py={0} key={i+1}>
                                            <Button
                                                className={props.classes.truncate}
                                                style={{justifyContent: "flex-start", height: "35px", paddingLeft: 0}}
                                                size="small"
                                                component="label"
                                                fullWidth
                                                type="button"
                                            >
                                                <Box>
                                                    <IconButton
                                                        style={{backgroundColor: "transparent"}}
                                                        aria-label="delete"
                                                        disableRipple
                                                        onClick={() => removeFileFromArray(file) }
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Box>

                                                {file.name || ""}
                                            </Button>
                                        </Box>
                                    ))}

                                    <Box py={1}>
                                        <Button
                                            className={props.classes.truncate}
                                            variant="outlined"
                                            size="medium"
                                            component="label"
                                            fullWidth
                                            type="button"
                                        >
                                            Choose file/s to upload
                                            <input type="file" multiple onChange={handleFileChange} hidden/>
                                        </Button>
                                    </Box>

                                    <Box py={1}>
                                        {showUploadProgress === true && <LinearProgress variant="determinate" value={uploadProgress} />}
                                    </Box>

                                    <Box py={1}>
                                        <Button
                                            variant="contained"
                                            size="medium"
                                            color="primary"
                                            fullWidth
                                            disableElevation
                                            disableRipple
                                            onClick={handleSubmit}
                                            disabled={disabled}
                                        >
                                            Submit Classwork
                                        </Button>
                                    </Box>
                                </form>
                            </>
                        )
                    }
                </Box>
            </Paper>
        </>
    );
}

export default ClassworkSubmissions;